/**
 * Created by lycheng on 2017/11/29.
 * 如果需要特殊的定制显示，请在调用init时传递数据，
 * 如果一个页面中有多个开通服务，请在调用showserviceOpenModal时传递数据，
 * 如果已有的不能满足你的需求，请在调用是通过传递参数的方式进行配置
 * 杜绝／鄙视使用像 if(serviceId === 'xxx')的行为
 * 杜绝／鄙视使用像 if(serviceId === 'xxx')的行为
 * 杜绝／鄙视使用像 if(serviceId === 'xxx')的行为
 */
import 'babel-polyfill'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import * as serviceApi from 'js/api/services'
import * as usersApi from 'js/api/user'
import * as sdkApi from 'js/api/sdk'
import { setQueryString } from 'js/libs/utils'
import { layer } from 'js/libs/utils-layer'
import { showLoginModal } from 'js/libs/utils-login'
import { getHtml } from 'js/libs/utils-services-open-html'
import { config } from 'config'
var ocrList = ['bankcard', 'general', 'hw', 'idcard', 'business_card', 'business_license', 'wfv', 'wwv', 'wsf', 'wcf', 'wtf', 'waf', 'dp', 'srl', 'sdp', 'cws-pos-ner', 'its', 'qbh', 'wsd', 'invoice', 'scene', 'currency', 'sex-age-expression-face_score', 'sa', 'ke', 'sdgp', 'recognize_document', 'rta', 'esriat', 'znyj']
var newFrameList = ['igr_gray', 'itr']
var serviceOpen = {
  config: {
    modalTitle: '选择应用',
    // 弹出框
    modalContainer: '.modal-wrapper-service-open',
    // 默认提示文字：如麦克风阵列的
    defaultTip: '',
    allOpenedTip: '',
    noAppTip: '',
    unOpenTitle: '',
    openedTitle: '',
    // 没有选择应用直接点击开通按钮的提示
    alertTip: '请选择应用',
    // 通过数据拼接的html追加的位置
    $container: $('.modal-wrapper-service-open .service-open-content'),
    // 是否允许被开通
    enableOpen: true,
    // 跳转链接中需要额外的参数
    urlParams: {}
  },
  data: {
    appId: '',
    appName: '',
    serviceId: '',
    serviceTitle: '',
    // 是否已经开通
    opened: '',
    // 详情页链接
    detailUrl: '',
    // 去开通详情页链接
    toOpenUrl: '',
    // 详情页是否新打开一个窗口
    detailTarget: '_self',
    getAppUrl: '',
    // app_id在url中的key
    appIdKey: 'app_id',
    // 是否需要base64 appid
    needBase64: true,
    // 是否需要appOs
    needAppOs: false,
    // 是否需要businessId
    needBusinessId: false
  }
}
/**
 * 打开弹出层
 * @param modalConfig 会覆盖serviceOpen.config中的数据
 * @param serviceData 会覆盖serviceOpen.data中的数据
 * @param modalContainer
 */
function showserviceOpenModal (modalConfig, serviceData, modalContainer) {
  modalConfig && (serviceOpen.config = $.extend(serviceOpen.config, modalConfig))
  serviceData && (serviceOpen.data = $.extend(serviceOpen.data, serviceData))
  serviceOpen.config.modalTitle && ($(`${serviceOpen.config.modalContainer} .modal-title`).text(serviceOpen.config.modalTitle))
  serviceOpen.config.modalContainer = modalContainer || serviceOpen.config.modalContainer
  rendModal()
}
function closeserviceOpenModal (modalContainer) {
  layer.close(modalContainer || serviceOpen.config.modalContainer)
  resetModal()
}
// 重置modal
function resetModal () {
  serviceOpen.data.appId = ''
  var $modal = $(serviceOpen.config.modalContainer)
  var $serviceAgreement = $modal.find('#service_agreement').get(0)
  $modal.find('.modal-button-ok').removeClass('disabled')
  $serviceAgreement && ($serviceAgreement.checked = true)
}
// 渲染弹出层
function rendModal (serviceId, serviceConfig) {
  serviceId = serviceId || serviceOpen.data.serviceId
  serviceConfig = serviceConfig ||
    {
      defaultTip: serviceOpen.config.defaultTip,
      noAppTip: serviceOpen.config.noAppTip,
      allOpenedTip: serviceOpen.config.allOpenedTip,
      unOpenTitle: serviceOpen.config.unOpenTitle,
      openedTitle: serviceOpen.config.openedTitle,
      agreementTitle: serviceOpen.data.agreementTitle,
      agreementUrl: serviceOpen.data.agreementUrl,
      serviceTitle: serviceOpen.data.serviceTitle,
      okButton: serviceOpen.config.okButton,
      enableOpen: serviceOpen.config.enableOpen
    }
  usersApi.checkLogin().then(function (loginResult) {
    var html
    if (loginResult.data) {
      layer.open(serviceOpen.config.modalContainer)
      html = getHtml('', 'loading')
      serviceOpen.config.$container.html(html)
      serviceApi.getApps().then(function (result) {
        if (result.code === 0 || result.code === '0') {
          html = getHtml(result.data, serviceConfig)
          serviceOpen.config.$container.html(html)
          if (result.data.length) {
            let container = '.service-opened-apps .swiper-container'
            let $swiperButton = $(`${container} .swiper-button`)
            new Swiper('.service-opened-apps .swiper-container', { // eslint-disable-line
              slidesPerView: 6,
              slidesPerGroup: 6,
              spaceBetween: 10,
              prevButton: '.service-opened-apps .swiper-button-prev',
              nextButton: '.service-opened-apps .swiper-button-next'
            })
            if (result.data.length <= 6) {
              $swiperButton.hide()
            } else {
              $swiperButton.show()
            }
          }
        } else {
          html = getHtml()
          serviceOpen.config.$container.html(html)
        }
      })
    } else {
      showLoginModal()
    }
  })
}
/**
 * 开通服务
 * @param serviceId
 * @param appId
 * @param detailUrl
 */
function openService (serviceId, appId, detailUrl) {
  var newWindow
  serviceId = serviceId || serviceOpen.data.serviceId
  appId = appId || serviceOpen.data.appId
  detailUrl = detailUrl || serviceOpen.data.detailUrl
  if (serviceOpen.data.opened) {
    // 进入详情页
    toDetail(serviceId, appId, detailUrl)
  } else if (!appId) {
    toDetail(serviceId, appId)
  } else {
    // 去开通
    // 解决ajax请求无法window.open窗口的问题
    if (serviceOpen.data.detailTarget === '_blank') {
      newWindow = window.open('/default/loading', '_blank')
    }
    // 判断是否是ocr
    if (ocrList.includes(serviceId)) {
      serviceApi.openOcrService(serviceId, appId).then(function (result) {
        if (result.code === 0 || result.code === '0') {
          // 进入详情页
          toDetail(serviceId, appId, detailUrl, newWindow)
        } else {
          // 开通失败
          jAlert(result.desc)
        }
      })
    } else if (newFrameList.includes(serviceId)) {
      serviceApi.openNewFrameService(serviceId, appId).then(function (result) {
        if (result.code === 0 || result.code === '0') {
          // 进入详情页
          toDetail(serviceId, appId, detailUrl, newWindow)
        } else {
          // 开通失败
          jAlert(result.desc)
        }
      })
    } else {
      serviceApi.openService(serviceId, appId).then(function (result) {
        if (result.code === 0 || result.code === '0') {
          // 进入详情页
          toDetail(serviceId, appId, detailUrl, newWindow)
        } else {
          // 开通失败
          jAlert(result.desc)
        }
      })
    }
  }
}
/**
 * 进入服务详情页
 * @param serviceId
 * @param appId
 * @param detailUrl
 */
function toDetail (serviceId, appId, detailUrl, newWindow) {
  serviceId = serviceId || serviceOpen.data.serviceId
  appId = appId || serviceOpen.data.appId
  if (!serviceOpen.data.opened && serviceOpen.data.toOpenUrl) {
    // toOpenUrl
    detailUrl = detailUrl || serviceOpen.data.toOpenUrl
  } else {
    detailUrl = detailUrl || serviceOpen.data.detailUrl
  }
  // 拼接跳转的链接
  detailUrl = setQueryString(serviceOpen.data.appIdKey, serviceOpen.data.needBase64 ? btoa(serviceOpen.data.appId) : serviceOpen.data.appId, detailUrl)
  // 链接添加appOs,businessId参数
  if (serviceOpen.data.needBusinessId) detailUrl = setQueryString('businessId', btoa(serviceId), detailUrl)
  if (serviceOpen.data.needAppOs && serviceOpen.data.appOs) detailUrl = setQueryString('appOs', serviceOpen.data.appOs, detailUrl)
  // 链接中的其他参数
  for (var p in serviceOpen.config.urlParams) {
    detailUrl = setQueryString(p, serviceOpen.config.urlParams[p] || serviceOpen.data[p], detailUrl)
  }
  if (!appId) {
    // 没有选择appId
    jAlert(serviceOpen.config.alertTip)
  } else {
    closeserviceOpenModal()
    if (newWindow) {
      // ajax请求后在新的窗口中打开
      newWindow.location.href = detailUrl
    } else {
      window.open(detailUrl, serviceOpen.data.detailTarget)
    }
  }
}
function bindEvent () {
  var $modal = $(serviceOpen.config.modalContainer)
  // modal中的按钮
  $modal.on('click', '.modal-button-ok', function () {
    // 确定开通
    var $this = $(this)
    if ($this.hasClass('disabled')) {
      return
    }
    if (serviceOpen.config.enableOpen) {
      openService()
    } else {
      toDetail()
    }
  }).on('click', '.modal-button-cancle, .modal-close', function () {
    closeserviceOpenModal()
  }).on('click', '.service-opened-apps li', function () {
    // 已经开通过的app
    var $appsBox = $('.service-open-apps')
    $appsBox.find('li.active').removeClass('active')
    $(this).addClass('active')
    serviceOpen.data.appId = $(this).data('appId')
    serviceOpen.data.appOs = $(this).data('appOs')
    serviceOpen.data.appName = $(this).data('appName')
    serviceOpen.data.opened = true
  }).on('click', '.service-unopen-apps li', function () {
    // 没有开通过的app
    var $appsBox = $('.service-open-apps')
    $appsBox.find('li.active').removeClass('active')
    $(this).addClass('active')
    serviceOpen.data.appId = $(this).data('appId')
    serviceOpen.data.appOs = $(this).data('appOs')
    serviceOpen.data.appName = $(this).data('appName')
    serviceOpen.data.opened = false
  }).on('change', '#service_agreement', function () {
    // 协议
    var $okButton = $modal.find('.modal-button-ok')
    if (this.checked) {
      $okButton.removeClass('disabled')
    } else {
      $okButton.addClass('disabled')
    }
  })
}
/**
 * 初始化
 * @param modalConfig 会覆盖serviceOpen.config中的数据
 * @param serviceData 会覆盖serviceOpen.data中的数据
 */
function init (modalConfig, serviceData) {
  serviceOpen.data.$modal = $(serviceOpen.config.modalContainer)
  serviceOpen.data.serviceId = serviceOpen.data.$modal.data('serviceId')
  serviceOpen.data.serviceTitle = serviceOpen.data.$modal.data('serviceTitle')
  serviceOpen.data.detailUrl = serviceOpen.data.$modal.data('detailUrl')
  let detailOrigin = serviceOpen.data.detailUrl && serviceOpen.data.detailUrl.substr(0, serviceOpen.data.detailUrl.indexOf('/'))
  if (detailOrigin && detailOrigin !== location.origin) {
    serviceOpen.data.detailTarget = '_blank'
  }
  serviceOpen.data.agreementTitle = serviceOpen.data.$modal.data('agreementTitle')
  serviceOpen.data.agreementUrl = serviceOpen.data.$modal.data('agreementUrl')
  modalConfig && (serviceOpen.config = $.extend(serviceOpen.config, modalConfig))
  serviceData && (serviceOpen.data = $.extend(serviceOpen.data, serviceData))
  bindEvent()
}
export {
  showserviceOpenModal,
  closeserviceOpenModal,
  init
}



// WEBPACK FOOTER //
// ./src/js/libs/utils-services-open.js